import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryTaxDetailsResponse, IInventoryTaxListResponseData } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryTaxDetailsAPI = () => {
  const [taxDetails, setTaxDetails] = useState<IInventoryTaxListResponseData>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (taxId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${INVENTORY_MODULE?.TAX_DETAILS?.baseURL}${taxId}/` , {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryTaxDetailsResponse>) => {
            if (res.data.status === true) {
              setTaxDetails(res.data.data);
            } else {
              setTaxDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setTaxDetails(null);
            captureError(e)
          });
      } catch (e: any) {
        setTaxDetails(null);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { taxDetails, execute };
};
